/**
 * Truncates the input string to the specified maximum length.
 *
 * @param input - The string to be truncated.
 * @param maxLength - The maximum length of the truncated string.
 * @returns The truncated string.
 */
export function truncateInput(input: string, maxLength: number): string {
    return input.slice(0, maxLength);
}
